import { render, staticRenderFns } from "./auto-class-config.vue?vue&type=template&id=fd171ace&scoped=true&"
import script from "./auto-class-config.ts?vue&type=script&lang=ts&"
export * from "./auto-class-config.ts?vue&type=script&lang=ts&"
import style0 from "./auto-class-config.scss?vue&type=style&index=0&id=fd171ace&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd171ace",
  null
  
)

export default component.exports